import React from 'react'
import WhatAreConservationAreas from '../content/what-are-conservation-areas.mdx'
import SectionTitle from '../components/section-title'
import QuestionButton from '../components/question-button'
import Dialog from './dialog'
import Table, { ITableRowData } from '../components/table'
import { getConservationAreaTableData } from '../utils/derivedData'

interface IProps {
  parcelsSelected: string[]
  parcelSpi?: string
  parcelData: any
  parcelAggregates: any
  areaData: any
  showHelp?: boolean
  titleFontSizePx?: string
}

interface IState {
  conservationHelpOpen: boolean
}

const ConservationAreas = class extends React.Component<IProps, IState> {
  static defaultProps: { showHelp: boolean }

  state = {
    conservationHelpOpen: false
  }

  setConservationHelpOpen = (open: boolean) => {
    this.setState(() => ({
      conservationHelpOpen: open
    }))
  }

  renderConservationAreasContent() {
    const { parcelSpi, parcelsSelected, parcelAggregates, parcelData, areaData } = this.props
    if (
      (!parcelSpi && parcelsSelected.length && parcelAggregates.conservationAreas.length === 0) ||
      (areaData && areaData.conservationAreas.length === 0)
    ) {
      return (
        <p>
          The selected {parcelsSelected.length ? 'parcel(s)' : 'area'} contain no conservation areas under the
          Biodiversity Conservation Strategy.
        </p>
      )
    } else if (!!parcelSpi && parcelData[parcelSpi].conservationAreas.length === 0) {
      return <p>None</p>
    } else {
      const conservationHeaders = ['ID', 'Type', 'Area']
      const conservationRows: ITableRowData[] = getConservationAreaTableData(
        parcelsSelected,
        parcelAggregates,
        areaData,
        parcelSpi,
        parcelData
      )
      return <Table headers={conservationHeaders} rows={conservationRows} />
    }
  }

  render() {
    const { showHelp, titleFontSizePx } = this.props
    const { conservationHelpOpen } = this.state
    return (
      <>
        <SectionTitle title="Conservation areas" titleFontSizePx={titleFontSizePx}>
          {showHelp && <QuestionButton onClick={() => this.setConservationHelpOpen(true)} />}
          <Dialog
            open={conservationHelpOpen}
            setPopupState={this.setConservationHelpOpen}
            heading="What are conservation areas?"
          >
            <WhatAreConservationAreas />
          </Dialog>
        </SectionTitle>
        {this.renderConservationAreasContent()}
      </>
    )
  }
}

ConservationAreas.defaultProps = {
  showHelp: true
}

export default ConservationAreas
